"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvalidResponseError = void 0;
class InvalidResponseError extends Error {
    constructor(missingFields) {
        super(`Invalid response from OIDC provider: missing fields ${missingFields}`);
        this.missingFields = missingFields;
    }
}
exports.InvalidResponseError = InvalidResponseError;
